<div
  class="tour-content"
  [ngClass]="{ 'step-1-image': tourStep === 1, 'step-2-image': tourStep === 2, 'step-3-image': tourStep === 3 }"
>
  <div class="tour-content-2">
    <div *ngIf="tourStep === 1">
      <div class="image-container dark-bg">
        <img class="medium-image" src="../../../../assets/public/home-illustration.png" />
      </div>
      <div class="text-container">
        <h2 class="text-center"><strong>Welcome to IRJ PRO</strong></h2>
        <div class="description">
          Rail Market Intelligence to power your business.
          <br />
          Get a clear and up-to-date picture of investment in new railways and rolling stock
          <br />
          together with the latest global rail tenders.
        </div>
      </div>
    </div>
    <div *ngIf="tourStep === 2">
      <div class="image-container">
        <img class="medium-image" src="../../../../assets/shared/graphics/projects-search-railway.png" />
      </div>
      <div class="text-container">
        <h2 class="text-center"><strong>Analyse the market</strong></h2>
        <div class="description">
          Compare investment around the world.
          <br />
          Take advantage of our easy-to-use filters,
          <br />
          tailor and select data to your precise needs.
        </div>
      </div>
      <!-- <h4>How to use IRJ Bi</h4>
      <p><strong>Monitor Railway Construction Projects</strong></p>
      <p>
        Details of all known railway construction projects around the globe, offering a unique perspective on infrastructure investment at local, national, regional,
        and global levels.
      </p>
      <p><strong>Follow the Constantly Updated Fleet Database</strong></p>
      <p>
        A worldwide database of all known locomotive and passenger rolling stock orders placed since 2012. Listing parameters such as: operator, owner, supplier,
        type and more.
      </p>
      <p><strong>View Global Rail Tenders</strong></p>
      <p>
        A worldwide database of all known locomotive and passenger rolling stock orders placed since 2012. Listing parameters such as: operator, owner, supplier,
        type and many more. Technical data included where possible.
      </p> -->
    </div>
    <div *ngIf="tourStep === 3">
      <div class="image-container">
        <img class="medium-image" src="../../../../assets/shared/graphics/tenders-custom-data.png" />
      </div>
      <div class="text-container">
        <h2 class="text-center"><strong>Quickly find the data you need</strong></h2>
        <div class="description">
          Apply filters to find the data that matters most to your business.
          <br />
          Save filters to manage different data sets and
          <br />
          to easily use them again in future.
        </div>
      </div>
    </div>
    <div *ngIf="tourStep === 4">
      <div class="image-container">
        <img class="medium-image" src="../../../../assets/shared/graphics/email-alerts-tenders.png" />
      </div>
      <div class="text-container">
        <h2 class="text-center"><strong>Stay up to date</strong></h2>
        <div class="description">
          Set up email notifications to be informed when data is updated.
          <br />
          Choose exactly which data sets and individual projects, fleets and tenders
          <br />
          you will be notified about.
        </div>
      </div>
    </div>
    <div class="button-container">
      <button mat-flat-button color="primary" [disabled]="tourStep < 2" (click)="prevStep()">Previous</button>
      <button
        mat-flat-button
        color="primary"
        *ngIf="tourStep < 4"
        (click)="nextStep()"
        class="next-button"
        cdkFocusInitial
      >
        Next
      </button>
      <button mat-flat-button color="primary" *ngIf="tourStep === 4" [mat-dialog-close]="null" class="next-button">
        Close
      </button>
    </div>
  </div>
</div>
